import { render, staticRenderFns } from "./InformeDevolucionesTab.vue?vue&type=template&id=bcf16768"
import script from "./InformeDevolucionesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeDevolucionesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports